import React, { useState } from "react";
import { useReactFlow } from "react-flow-renderer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlassMinus, faMagnifyingGlassPlus } from "@fortawesome/free-solid-svg-icons";
import { useT } from "../i18n/LanguageContext";
import "./AreaJumpButton.css";

// Centers of the three board areas in canvas coordinates (see dtZones
// AREA_BOUNDS) — Deck, then Brainstorming, then Lavagna (least-used, so it
// trails last). Nominal (tradizionale) positions only: doesn't account for
// scenari_futuri's dynamic growth, same precision level as before.
// `key` and `labelKey` are internal ids; the display label is resolved via
// t(labelKey) at render time — see the AREAS.map below.
export const AREAS = [
  { key: "deck",       labelKey: "canvas.areas.deck",       view: { x: 880,  y: 1000, zoom: 0.34 } },
  { key: "brainstorm", labelKey: "canvas.areas.brainstorm", view: { x: 3000, y: 1000, zoom: 0.30 } },
  { key: "lavagna",    labelKey: "canvas.areas.lavagna",    view: { x: 4840, y: 1000, zoom: 0.40 } },
];

// One merged bottom bar: dashboard-area navigation + zoom + brainstorming
// mode, instead of three separate floating panels competing for the same
// strip of screen. Kept as a single component (rather than assembled piece
// by piece in InfiniteCanvas.js) so the AREAS/jump logic stays local to
// where it's defined — InfiniteCanvas only wires in the zoom/mode bits it
// already owns.
export default function AreaJumpButton({ sessionMode, zoom, onZoomIn, onZoomOut, onFitView, onModeChange, modeOptions }) {
  const { setCenter } = useReactFlow();
  const [active, setActive] = useState("deck");
  const t = useT();

  const go = (a) => {
    setCenter(a.view.x, a.view.y, { zoom: a.view.zoom, duration: 800 });
    setActive(a.key);
  };

  return (
    <div className="area-nav">
      {AREAS.map((a) => (
        <button
          key={a.key}
          type="button"
          className={`area-nav__btn${active === a.key ? " is-active" : ""}`}
          onClick={() => go(a)}
        >
          {a.key === "brainstorm" && sessionMode === "scenari_futuri" ? t('canvas.areaJump.scenariFuturi') : t(a.labelKey)}
        </button>
      ))}
      <span className="area-nav__sep" />
      <button type="button" className="area-nav__icon" title={t('canvas.areaJump.zoomOut')} aria-label={t('canvas.areaJump.zoomOut')} onClick={onZoomOut}>
        <FontAwesomeIcon icon={faMagnifyingGlassMinus} />
      </button>
      <button
        type="button"
        className="area-nav__icon area-nav__icon--text"
        title={t('canvas.areaJump.fitView')}
        aria-label={t('canvas.areaJump.fitView')}
        onClick={onFitView}
      >
        {Math.round((zoom || 0) * 100)}%
      </button>
      <button type="button" className="area-nav__icon" title={t('canvas.areaJump.zoomIn')} aria-label={t('canvas.areaJump.zoomIn')} onClick={onZoomIn}>
        <FontAwesomeIcon icon={faMagnifyingGlassPlus} />
      </button>
      <span className="area-nav__sep" />
      <select
        className="area-nav__select"
        title={t('canvas.areaJump.modeSelect')}
        aria-label={t('canvas.areaJump.modeSelect')}
        value={sessionMode || 'tradizionale'}
        onChange={onModeChange}
      >
        {modeOptions}
      </select>
    </div>
  );
}
